var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ticket",
      class: {
        "ticket--special":
          _vm.ticketConfiguration.specialProduct ||
          (_vm.ticketConfiguration.isAdditionalProduct &&
            (!_vm.disableDecrease || !_vm.disableIncrease)),
        "ticket--additional--disabled":
          (_vm.ticketConfiguration.isAdditionalProduct &&
            _vm.disableDecrease &&
            _vm.disableIncrease) ||
          _vm.isSoldOut,
      },
    },
    [
      _c("ticket-description", {
        key: "description-" + _vm.ticketConfiguration.id,
        attrs: {
          ticketConfiguration: _vm.ticketConfiguration,
          "sold-out": _vm.isSoldOut,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ticket_right" }, [
        _c(
          "div",
          [
            _c("ticket-price", {
              key: "price-" + _vm.ticketConfiguration.id,
              attrs: {
                ticketConfiguration: _vm.ticketConfiguration,
                "on-site-products": _vm.onSiteProducts,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ticket__amount--mobile" }, [
          _c("div", { staticClass: "ticket__amount" }, [
            _c(
              "button",
              {
                staticClass: "ticket__amountChange",
                attrs: { disabled: _vm.disableDecrease },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.decrementQuantity(_vm.ticketConfiguration)
                  },
                },
              },
              [_vm._v("\n         –\n       ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number.lazy",
                  value: _vm.ticketConfiguration.quantity,
                  expression: "ticketConfiguration.quantity",
                  modifiers: { number: true, lazy: true },
                },
              ],
              staticClass: "ticket__amountInput",
              attrs: {
                type: "number",
                min: "0",
                step: "1",
                disabled: _vm.disableIncrease && _vm.disableDecrease,
              },
              domProps: { value: _vm.ticketConfiguration.quantity },
              on: {
                change: function ($event) {
                  _vm.$set(
                    _vm.ticketConfiguration,
                    "quantity",
                    _vm._n($event.target.value)
                  )
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "ticket__amountChange ticketConfiguration__amountChange--add",
                attrs: { disabled: _vm.disableIncrease },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.incrementQuantity(_vm.ticketConfiguration)
                  },
                },
              },
              [_vm._v("\n         +\n       ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ticket__cart" }, [
            _c(
              "button",
              {
                staticClass: "ticket__cartButton button",
                attrs: {
                  disabled:
                    _vm.ticketConfiguration.quantity === 0 ||
                    !_vm.reachedMinPositionQuantity ||
                    _vm.loading,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.addToCart(_vm.ticketConfiguration)
                  },
                },
              },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("global.links.addToShoppingCart"))),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }